import React from 'react';
import { IAppRoute } from '../route/types';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'react-bootstrap-icons';

type IProps = {
    children?: any,
    route: IAppRoute,
};

const AuthLayout = ({ route, children }: IProps) => (
  <>
    <div className="wrap-login">
      <div className="logo-login"></div>
      <div className="auth-wrapper">
        <div className="wrap-title-login">
          <div className="title-login">{route.name || route.pageTitle}</div>
          <Link className="link-title-register" to={"/register"}>
            Registreren
            <ArrowRight color="#1F4464" size={40} />
          </Link>
        </div>
        <div className="auth-inner">{children || null}</div>
        <div className="wrap-title-login">
          <div className="bg-graphic-small"></div>
          <div className="footer"> &copy;{new Date().getFullYear()} FNO</div>
        </div>
        <div className="bg-graphic-large"></div>
      </div>
    </div>
  </>
);

export default AuthLayout;
